import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  return <section id="top" className="min-h-[90vh] flex items-center pt-20 pb-12 relative overflow-hidden" data-id="element-74">
      {/* Bold terracotta accent bar */}
      <motion.div initial={{
      scaleY: 0
    }} animate={{
      scaleY: 1
    }} transition={{
      duration: 1,
      ease: [0.22, 1, 0.36, 1]
    }} className="absolute left-0 top-0 bottom-0 w-3 md:w-6 bg-accent origin-top" aria-hidden="true" data-id="element-75" />

      {/* Warm accent glow */}
      <div className="absolute -right-40 top-1/4 w-[500px] h-[500px] rounded-full bg-accent opacity-[0.07] blur-3xl pointer-events-none" aria-hidden="true" data-id="element-76" />

      <div className="max-w-6xl mx-auto px-8 md:px-16 w-full relative z-10" data-id="element-77">
        <div className="max-w-3xl" data-id="element-78">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-6" data-id="element-79">
            <span className="inline-block bg-accent text-white px-4 py-1.5 text-sm font-bold tracking-widest uppercase" data-id="element-80">
              Product Manager
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-5xl md:text-7xl font-serif text-text-primary leading-[1.1] mb-8" data-id="element-81">
            I build mobile products that navigate complexity and deliver
            clarity.
          </motion.h1>

          <motion.div initial={{
          scaleX: 0
        }} animate={{
          scaleX: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5,
          ease: 'easeOut'
        }} className="h-1.5 w-32 bg-accent-secondary mb-8 origin-left" aria-hidden="true" data-id="element-82" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="text-xl text-text-secondary leading-relaxed mb-10 max-w-2xl" data-id="element-83">
            Specializing in highly-regulated environments, I bridge the gap
            between strict compliance and seamless customer experiences.
          </motion.p>

          {/* Stat strip with colored backgrounds */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="flex flex-wrap items-center gap-3 mb-12" data-id="element-84">
            <span className="bg-accent/10 text-accent font-bold text-sm px-4 py-2 tracking-wide" data-id="element-85">
              8+ Years
            </span>
            <span className="bg-accent-secondary/10 text-accent-secondary font-bold text-sm px-4 py-2 tracking-wide" data-id="element-86">
              12 Products Shipped
            </span>
            <span className="bg-dark text-white font-bold text-sm px-4 py-2 tracking-wide" data-id="element-87">
              3 Regulated Industries
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.7
        }} data-id="element-88">
            <a href="#work" className="inline-flex items-center space-x-2 bg-accent text-white px-8 py-4 font-bold hover:bg-accent-secondary transition-colors duration-300 group" data-id="element-89">
              <span data-id="element-90">View Selected Work</span>
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-91" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}